import React, { PropTypes, Component } from 'react';
import { VehicleDetails } from '../../../../components/vehicle';
import { NitroButton, NitroDivider, NitroSingleSelect, NitroPanel, NitroGrid } from 'nitro-components';

import styled from 'styled-components';

const SelectButton = styled.div`
  margin: 20px 0 10px;
`;

class VehicleCard extends Component {
  constructor(props, context) {
    super(props, context);

    const { TermDistance } = this.props.vehicle;

    const sortedTermDistance = TermDistance.sort(function(a, b) {
      if (a.Term === b.Term) {
        return b.Distance - a.Distance;
      } else {
        return b.Term - a.Term;
      }
    });

    const termOptions = sortedTermDistance.map(term => ({
      label: `${term.Term} Months - ${term.Distance}km`,
      value: `${term.Term} Months - ${term.Distance}km`,
      term
    }));

    this.state = {
      termOptions,
      selectedTerms: termOptions[0]
    };
  }

  handleSelectChange = selectedTerms => {
    this.setState({ selectedTerms });
  };

  render() {
    const { vehicle, action } = this.props;
    const { termOptions, selectedTerms } = this.state;

    return (
      <NitroGrid grid={3}>
        <NitroPanel noMargin padding="16px">

          <VehicleDetails {...vehicle} disablePanelClick showStats />

          <NitroDivider noMarginTop />

          <NitroSingleSelect
            mandatory
            value={selectedTerms.value}
            options={termOptions}
            action={selectedTerms => this.handleSelectChange(selectedTerms)}
          />

          <SelectButton>
            <NitroButton
              variant="primary"
              block
              label="Select"
              size="small"
              action={() => action(vehicle, selectedTerms.term)}
            />
          </SelectButton>

        </NitroPanel>
      </NitroGrid>
    );
  }
}

VehicleCard.propTypes = {
  vehicle: PropTypes.object.isRequired,
  action: PropTypes.func.isRequired
};

export default VehicleCard;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/create/components/VehicleCard.js